import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VIEW_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import ViewForm from './ViewForm';
import { postView } from '../../../../actions/security/View';

export const NewView = ({ dispatchPostView, loading, breadcrumbs }) => {

  const onSubmit = (formValues) => {
    dispatchPostView(formValues);
  };

  const content = loading ? (
    <Loader />
  ) : (
    <ViewForm
      onSubmit={onSubmit}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Vista"
      subtitle="Crear una nueva vista"
      content={content}
    />
  );
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Seguridad',
      href: VIEW_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
  loading: !SecurityUnit.View.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchPostView: postView,
};

NewView.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostView: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

NewView.defaultProps = {
  loading: false,
};

export default connect(mapStateToProps,mapDispatchToProps)(NewView);
